import type {Workspace} from "stores/layoutStore";

/**
 * The scan page's workspace in the browser history — not in the URL, which the scan
 * selection owns (`scanParams`), but in the entries' state, next to the router's own keys.
 * Only a change that wants Back to undo it (View Analysis) writes an entry; switching
 * folders by hand does not pile up history.
 */

const KEY = 'workspace';

/** Stamp the current entry with the workspace being left and push one for the next. */
export const pushWorkspaceEntry = (from: Workspace, to: Workspace) => {
    const {history} = window;
    history.replaceState({...history.state, [KEY]: from}, '');
    history.pushState({...history.state, [KEY]: to}, '');
};

/** The workspace an entry was stamped with, if any. */
export const readWorkspaceEntry = (state: unknown): Workspace | null => {
    const value = (state as Record<string, unknown> | null)?.[KEY];
    return value === 'scan' || value === 'humanizer' ? value : null;
};
